module.exports = __webpack_public_path__ + "fonts/inter-v2-latin-700.woff2?334d1833a21eac00610249bcafff9c3b";